import Image from 'next/image';
import React from 'react';
import { paths } from 'src/config/paths';

import { Button, Text } from '@/design-system/components/ui';

import { RouterLink } from './RouterLink';

interface Props {
  code?: number;
  error: string;
  href?: string;
  action?: string;
}

export const ErrorScreen = ({ code = 404, error, href = paths.index, action = 'Back to Home' }: Props) => {
  return (
    <main className="tw:flex tw:items-center tw:grow tw:bg-[var(--mui-palette-background-default)] tw:text-[var(--mui-palette-text-primary)]">
      <div className="tw:container tw:max-w-screen-lg tw:mx-auto tw:px-6">
        <div className="tw:flex tw:flex-col tw:gap-6 tw:items-center">
          <div className="tw:relative tw:w-[150px] tw:h-[150px] tw:md:w-[200px] tw:md:h-[200px]">
            <Image
              src="/assets/errors/error-404.webp"
              alt="The page you are looking for isn't here"
              priority
              style={{
                objectFit: 'contain',
              }}
              fill
            />
          </div>
          <Text variant="title-sm" as="h3" className="tw:text-center">
            {code}: {error}
          </Text>
          <Button variant="primary" asChild>
            <RouterLink href={href}>{action}</RouterLink>
          </Button>
        </div>
      </div>
    </main>
  );
};
